import React from 'react';
import { CContainer, CSpinner, CRow, CCol } from '@coreui/react';

const LoadingScreen = ({ message = "A carregar...", containerHeight='100vh' }) => {
    return (
        <CContainer className="d-flex flex-column justify-content-center align-items-center" style={{ height: containerHeight }}>
            <CSpinner color="primary" style={{ width: "4rem", height: "4rem" }} />
            <CRow className="mt-3">
                <CCol className="text-center">
                    <span className="text-muted fs-5 fw-semibold">{message}</span>
                </CCol>
            </CRow>
        </CContainer>
    );
};

export default LoadingScreen;